<template>
    <div class="event-edit">
        <template v-if="!event.provider">
            No Doctor selected for this event
        </template>
        <template v-else-if="!event.id">
            <el-date-picker
                v-model="event.time"
                type="date"
                format="MM/dd/yyyy"
                placeholder="Event date"
                size="small"
                style="width:150px">
            </el-date-picker>
            &nbsp;
            <el-select
                v-model="event.id"
                placeholder="Select Event"
                filterable
                style="width:230px"
                size="small"
                @change="$emit('select')">
                <el-option-group key="suggested" label="Suggested">
                    <el-option
                        v-for="e in suggestedEvents"
                        :key="e.id"
                        :label="getEventLabel(e)"
                        :value="e.id">
                    </el-option>
                </el-option-group>
                <el-option-group key="all" label="All Events">
                    <el-option
                        v-for="e in events.filter((ev) => !event.match.includes(ev.id))"
                        :key="e.id"
                        :label="getEventLabel(e)"
                        :value="e.id">
                    </el-option>
                </el-option-group>
            </el-select>
        </template>
        <template v-else>
            <i class="el-icon-date" style="margin-right: 10px;"></i>
            <strong>{{ getContentKey('event', event.id, 'name') }}</strong> on <strong>{{ formatDate(event.time, true, true) }}</strong>
            <el-button type="text" class="edit-button" @click="$emit('edit')" v-if="confirm">
                <EditIcon></EditIcon> Edit
            </el-button>
            <template v-if="alreadyScheduled">
                <span class="same-schedule">  <i class="el-icon-check"></i> Same Event already scheduled</span>
            </template>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Icons from '@/module/add/icons'


import formatDate from '@/module/util/format-date'
import sameDay from '@/module/util/same-day'

export default {
    name: 'event-edit',
    props: {
        /**
         * The event Object from patient
         */
        event: {
            type: Object
        },
        /**
         * The flag whether this event needs confirmation from MA
         */
        confirm: {
            type: Boolean,
            default: true
        },
    },
    methods: {
        formatDate,
        /**
         * Returns event label depending on single of multi-profiles
         * @param {Object} event Event contentobject to create label for
         */
        getEventLabel(event) {
            let label = event.name
            // Add profile name if multiple profiles
            if(this.provider.profile.length > 1)
                label += ` (${event.profile})`
            return label
        }
    },
    computed: {
        ...mapGetters('provider', [ 'getProvider', 'getProviderList' ]),
        ...mapGetters('content', [ 'getContent', 'getContentKey' ]),
        /**
         * Calculates the provider to be used by finding it from current event 
         * in `event.provider`
         *
         * @returns {Object}
         */
        provider() {
            const patientProvider = this.getProviderList.find((currProvider) => currProvider.provider === this.event.provider)
            if(patientProvider)
                return patientProvider
			return this.getProvider
        },
        /**
         * Calculates the list of events where the MA can choose from,
         * it depends on the `provider` computed property
         *
         * @returns {[Object]}
         */
        events() {
			return this.provider.profile.flatMap((profile) => (
                profile.event.map((eventId) => this.getContent('event', eventId) ? {...this.getContent('event', eventId), profile: profile.title} : null)
                )).filter((e) => e != null)
        },
        /**
         * Maps suggested events to there event objects
         */
        suggestedEvents() {
            try {
                return this.events.filter((event) => this.event.match.includes(event.id))
            } catch (error) {
                return []
            }
        },
        /**
         * Calculates whether the event has been already scheduled for the patient
         *
         * @returns {Boolean}
         */
        alreadyScheduled() {
			if(this.event && this.event.id && this.event.futureEvents)
				return this.event.futureEvents.some((futureEvent) => futureEvent.event === this.event.id && sameDay(this.event.time, futureEvent.time))
			return false
        }
    },
    components: {
        ...Icons
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>